/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { View, Text, type CustomOptionsProps } from '@az/starc-ui';

export function CustomOption({ label, isFocused, isSelected }: CustomOptionsProps) {
  return (
    <View attributes={{ 'data-state': isFocused ? 'focused' : isSelected ? 'selected' : '' }}>
      <View.Item>
        <Text>{label}</Text>
      </View.Item>
    </View>
  );
}
